import Vue from 'vue'
import Router from 'vue-router'
import {
    Message
} from 'element-ui';
// import HelloWorld from '@/components/HelloWorld'
import login from '@/pages/login'
import mainFrame from '@/pages/mainFrame'
import error from '@/pages/404.vue'
import home from '@/pages/home/index'
//用户管理
import customerList from '@/pages/customer/list'
import customerDetail from '@/pages/customer/detail'
//订单管理
import orderList from '@/pages/order/list'
import orderAddCmt from '@/pages/order/addCmt'
import orderAddOem from '@/pages/order/addOem'
import orderEditCmt from '@/pages/order/editCmt'
import orderEditOem from '@/pages/order/editOem'
import orderDetail from '@/pages/order/detail'
import factoryDetail from '@/pages/order/factoryDetail'
import brandCompanyDetail from '@/pages/order/brandCompanyDetail'
import orderProgressEdit from '@/pages/order/progressEdit'
import selectProducer from '@/pages/order/selectProducer'
//系统管理
import leftMenuManager from '@/pages/system/leftMenuManager'
import userManager from '@/pages/system/userManager'
import roleManager from '@/pages/system/roleManager'
import functionManager from '@/pages/system/functionManager'
//公共
import editPwd from '@/pages/commonPage/editPwd'



Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/mainFrame',
            name: 'mainFrame',
            component: mainFrame,
            children: [
                {
                    path: '/404',
                    name: '404',
                    component: error
                },
                {
                    path: '/home',
                    name: 'home',
                    component: home,
                    meta:{firstMenuUrl:'/home'}
                },
                //公共
                {
                    path: '/editPwd',
                    name: 'editPwd',
                    component: editPwd
                },
                //订单管理
                {
                    path: '/orderList',
                    name: 'orderList',
                    component: orderList,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                {
                    path: '/orderAddCmt/:userId/:companyName/:user_cellphone',
                    name: 'orderAddCmt',
                    component: orderAddCmt,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                {
                    path: '/orderAddOem/:userId/:companyName/:user_cellphone',
                    name: 'orderAddOem',
                    component: orderAddOem,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                {
                    path: '/orderEditCmt/:orderNumber/:orderType/:fdUserId',
                    name: 'orderEditCmt',
                    component: orderEditCmt,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                {
                    path: '/orderEditOem/:orderNumber/:orderType/:fdUserId',
                    name: 'orderEditOem',
                    component: orderEditOem,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                {
                    path: '/orderDetail/:orderNumber/:orderType',
                    name: 'orderDetail',
                    component: orderDetail,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                {
                    path: '/orderProgressEdit/:orderNumber',
                    name: 'orderProgressEdit',
                    component: orderProgressEdit,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                {
                    path: '/selectProducer/:orderNumber',
                    name: 'selectProducer',
                    component: selectProducer,
                    meta:{firstMenuUrl:'/order',secondMenuUrl:'/orderList'}
                },
                //客户管理
                {
                    path: '/customerList',
                    name: 'customerList',
                    component: customerList,
                    meta:{firstMenuUrl:'/customer',secondMenuUrl:'/customerList'}
                },
                {
                    path: '/customerDetail/:userId/:href',
                    name: 'customerDetail',
                    component: customerDetail,
                    meta:{firstMenuUrl:'/customer',secondMenuUrl:'/customerList'}
                },
                //系统管理
                {
                    path: '/leftMenuManager',
                    name: 'leftMenuManager',
                    component: leftMenuManager,
                    meta:{firstMenuUrl:'/system',secondMenuUrl:'/leftMenuManager'}
                },
                 {
                    path: '/userManager',
                    name: 'userManager',
                    component: userManager,
                    meta:{firstMenuUrl:'/system',secondMenuUrl:'/userManager'}
                },
                {
                    path: '/roleManager',
                    name: 'roleManager',
                    component: roleManager,
                    meta:{firstMenuUrl:'/system',secondMenuUrl:'/roleManager'}
                },
                {
                    path: '/functionManager',
                    name: 'functionManager',
                    component: functionManager,
                    meta:{firstMenuUrl:'/system',secondMenuUrl:'/functionManager'}
                }
                

            ]
        },
        {
            path: '*',
            redirect: '/404'
        },
    ]
})
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) 
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}

function getBrowser(cname){
    return getCookie(cname)
}
router.beforeEach((to, from, next) => {
    if(window.gtag){
        gtag('config','G-9WED1NW577',{'page_path': to.fullPath})
    }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "衣加加产业云平台管理后台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        Message({
            message: "请先登录~",
            type: 'warning',
            duration: 500
        });
        setTimeout(function() {
            router.push("/login")
        }, 500)
    }
    // console.log(to, from)
    let isLogined = getBrowser("isLoginedYjjAdminMultiActive")
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js